export type GoogleAdsConversionParams = {
    sendTo: string;
    value: number;
    currency: string;
    transactionId: string;
};

let googleAdsInitializedSendTo: string | null = null;

export function parseGoogleAdsSendTo(configValue: string | undefined | null): string | null {
    const sendTo = configValue?.trim();
    if (!sendTo || !sendTo.includes("/")) return null;
    return sendTo;
}

function getConversionId(sendTo: string): string | null {
    const conversionId = sendTo.split("/")[0]?.trim();
    return conversionId?.startsWith("AW-") ? conversionId : null;
}

export function ensureGtagForGoogleAds(sendTo: string): void {
    const conversionId = getConversionId(sendTo);
    if (!conversionId) return;
    if (googleAdsInitializedSendTo === sendTo) return;
    googleAdsInitializedSendTo = sendTo;

    window.dataLayer = window.dataLayer || [];
    if (!window.gtag) {
        window.gtag = function gtag(...args: unknown[]) {
            window.dataLayer.push(args);
        };
    }

    const script = document.createElement("script");
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(conversionId)}`;
    document.head.appendChild(script);

    window.gtag("js", new Date());
    window.gtag("config", conversionId);
}

export function initGoogleAdsConversion(sendTo: string): void {
    if (!window.gtag) return;

    const conversionId = getConversionId(sendTo);
    if (!conversionId) return;

    window.gtag("config", conversionId);
}

export function trackGoogleAdsConversion(params: GoogleAdsConversionParams): void {
    if (!window.gtag || !params.sendTo) return;

    window.gtag("event", "conversion", {
        send_to: params.sendTo,
        value: params.value,
        currency: params.currency,
        transaction_id: params.transactionId,
    });
}

declare global {
    interface Window {
        dataLayer: unknown[];
        gtag: (...args: unknown[]) => void;
    }
}
